import React from 'react'
import { Link } from 'react-router-dom'

const Landing = () => {
  const items = [
    {
      header: 'Simplicity',
      icon: 'toll',
      content: 'Our familiar UI has everything you need in place',
    },
    {
      header: 'Personalization',
      icon: 'person',
      content:
        'Create unlimited playlists from wide collection of songs available ',
    },
    {
      header: 'PWA Support',
      icon: 'app_settings_alt',
      content:
        'Have no space? Worry no more. Enjoy our fully featured app-like experience. Just add to home screen',
    },
  ]
  return (
    <>
      <div className="landing-head">
        <div>
          <div>Enjoy free music Anywhere and Anytime</div>
          <p style={{ marginTop: `16px` }}>
            <Link
              to="/feed"
              className="goto-app btn"
              style={{
                color: `#fff`,
                fontSize: `18px`,
                letterSpacing: `1px`,
              }}
            >
              Go to App
            </Link>
          </p>
        </div>
      </div>

      <div className="whoarewe">
        <div>
          <div
            style={{
              paddingTop: `16px`,
            }}
          >
            <iframe
              width="320"
              height="200"
              title="who are we"
              frameBorder={0}
              src="https://www.youtube.com/embed/Fqch5OrUPvA"
              // src="https://www.youtube.com/embed/3z02rbPnUtg"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div
            style={{
              paddingTop: `16px`,
            }}
          >
            <h4>Who are we</h4>
            <div
              style={{
                minWidth: `270px`,
                maxWidth: `500px`,
              }}
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores,
              expedita, excepturi repellat est incidunt aspernatur voluptatum
              blanditiis fuga natus, minus esse suscipit aut voluptates aperiam
              beatae. Officiis corrupti ab accusamus?
            </div>
          </div>
        </div>
      </div>

      <div className="item-container">
        <h3
          className="ihead"
          style={{
            margin: `auto`,
            width: `90%`,
          }}
        >
          Something
        </h3>
        <div className="items">
          {items.map(({ content, header, icon }, i) => (
            <div className="item" key={i}>
              <div className="item-icon">
                <i className="material-icons-outlined md-36">{icon}</i>
              </div>
              <div className="item-body">
                <div className="item-header">
                  <h4>{header}</h4>
                </div>
                <div className="item-content">{content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className="footer"
        style={{
          width: `100%`,
          minHeight: `40vh`,
          background: `#000`,
          paddingTop: `24px`,
        }}
      >
        <div>
          <div className="logo">
            <i className="material-icons-outlined">album</i>
            <span>Lodies</span>
          </div>
          <ul className="company">
            <li className="fhead">
              <h4>Company</h4>
            </li>
            <li>About</li>
            <li>Privacy</li>
            <li>Reach out</li>
          </ul>
          <ul className="biz">
            <li className="fhead">
              <h4>Business</h4>
            </li>
            <li>Invest</li>
            <li>Advertise</li>
            <li>Develop</li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Landing
